import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { render } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import { setSchedulePaymentForm } from "../api/Client";
import { PaymentMethodComponent } from "./PaymentMethodComponent";
import { PreserveOrdererFormComponent } from "./schedule/PreserveOrdererFormComponent";
const ActionButton = ({ paymentMethodComponent, ordererComponent, payType, }) => {
    const [processing, setProcessing] = useState(false);
    const [paymentFormValid, setPaymentFormValid] = useState(false);
    const [ordererFormValid, setOrdererFormValid] = useState(false);
    const paymentFormSyncronizer = () => {
        const paymentForm = paymentMethodComponent.current?.getPaymentFormObject();
        if (paymentForm) {
            setSchedulePaymentForm(paymentForm).then(_ => {
                setPaymentFormValid(true);
            }).catch(e => {
                throw e;
            }).finally(() => {
                setProcessing(false);
            });
        }
    };
    const paymentFormInvalidator = () => {
        setPaymentFormValid(false);
    };
    useEffect(() => {
        document.addEventListener('--get-token-finish', paymentFormSyncronizer);
        document.addEventListener('--get-token-invalidate', paymentFormInvalidator);
        setPaymentFormValid(payType === 'PAY_ON_THE_DAY');
    }, []);
    const handleClick = async () => {
        setProcessing(true);
        try {
            await ordererComponent.current.setSession();
        }
        finally {
            setOrdererFormValid(ordererComponent.current?.hasErrors() === false);
            setProcessing(false);
            console.log(payType);
            if (payType === "PAY_ADVANCE") {
                paymentMethodComponent.current?.submitHook();
            }
        }
    };
    useEffect(() => {
        if (ordererFormValid && paymentFormValid) {
            location.href = "/schedules/confirm";
        }
    }, [ordererFormValid, paymentFormValid]);
    return (_jsx("a", Object.assign({ class: "button button__danger button__md button__block", onClick: handleClick }, { children: processing ? '処理中' : 'ご入力内容の確認' }), void 0));
};
export const SchedulePayOrdererComponent = ({ storeId, storeType, payType, }) => {
    // MEMO: iframeが大量発生するのでrefに避難させている
    const paymentMethodComponent = useRef();
    const ordererComponent = useRef();
    return (_jsxs("article", { children: [_jsxs("div", Object.assign({ class: `${payType === "PAY_ADVANCE" ? '' : 'is-hidden'}` }, { children: [_jsxs("h4", Object.assign({ class: "content__title" }, { children: [_jsx("span", { class: "heading" }, void 0), "\u652F\u6255\u65B9\u6CD5\u5165\u529B"] }), void 0),
                    _jsx(PaymentMethodComponent, { storeId: storeId, storeType: storeType, cartType: "SCHEDULE", ref: paymentMethodComponent }, void 0)] }), void 0),
            _jsx(PreserveOrdererFormComponent, { ref: ordererComponent }, void 0),
            _jsx("footer", { children: _jsxs("div", Object.assign({ class: "flex flex__row my2" }, { children: [_jsx("a", Object.assign({ class: "button button__secondary button__block button__md mr2", onClick: () => { history.back(); } }, { children: "\u623B\u308B" }), void 0),
                        _jsx(ActionButton, { payType: payType, ordererComponent: ordererComponent, paymentMethodComponent: paymentMethodComponent }, void 0)] }), void 0) }, void 0)] }, void 0));
};
document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('#SchedulePayOrdererComponent');
    if (root) {
        const storeId = Number(root.getAttribute('data-store-id'));
        const storeType = root.getAttribute('data-store-type');
        const payType = root.getAttribute('data-paytype');
        render(_jsx(SchedulePayOrdererComponent, { storeId: storeId, storeType: storeType, payType: payType }, void 0), root);
    }
});
